<template>
  <div>
    <page-main
      :tableData="tableData"
      :loading="loading"
      :disabled="disabled"
      @reload="reload"
      ref="main"
    >
      <page-header ref="header" slot="header" :disabled="disabled" />
    </page-main>
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [BaseTable, EditLoading],
  components: {
    PageHeader,
    PageMain,
  },
  props: {
    shipmentCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.loading = true
      this.$api
        .shipmentContainerListApi({
          shipmentCode: this.shipmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    getTableData() {
      return this.$refs.main.getTableData()
    },
    validate() {
      return this.$refs.main.validate()
    },
  },
}
</script>
